/**
 * HomeSLDemoCrmContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoCrmContent
 */

import { useHomeSLDemoCrmContentLogic } from '@/hooks/traits/useHomeSLDemoCrmContentLogic';
import type { HomeSLDemoCrmContentConfig } from '@/hooks/traits/useHomeSLDemoCrmContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoCrmDeal } from '@app/shared';
import { Card } from '@almadar/ui/components';
import { Split } from '@almadar/ui/components';
import { HomeSLDemoCrmStageChartView } from '@/components/traits/HomeSLDemoCrmStageChartView';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { HomeSLDemoCrmBoardView } from '@/components/traits/HomeSLDemoCrmBoardView';
import { HomeSLDemoCrmStatsView } from '@/components/traits/HomeSLDemoCrmStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLDemoCrmContentViewProps {
  config?: Partial<HomeSLDemoCrmContentConfig>;
}

export function HomeSLDemoCrmContentView({ config: propsConfig }: HomeSLDemoCrmContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLDemoCrmContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoCrmDeal'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLDemoCrmContent">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" direction="vertical" className="p-5"><Stack direction="vertical" gap="none"><Typography variant="h3" content={renderPatternValue(__t("std-almadar-demo-crm-page:page.title"))} /><Typography content={renderPatternValue(__t("std-almadar-demo-crm-page:page.subtitle"))} color="muted" variant="small" /></Stack><Split ratio="4:1" gap="md"><HomeSLDemoCrmBoardView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Stack gap="md" direction="vertical"><HomeSLDemoCrmStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeSLDemoCrmStageChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLDemoCrmContentView;
